<!--
 * @Author: 仙道
 * @Date: 2022-06-15 21:14:53
 * @LastEditTime: 2022-12-19 14:48:17
 * @email: hao.li08@weimob.com
 * @Description:
 * @FilePath: /iplus-iwt-fe/src/views/equipment/account/modules/components/BaseInfo.vue
-->
<template>
  <div class="c-tabs-panel pl-15px">
    <a-descriptions bordered class="mt-15px" size="small" title="运行情况">
      <a-descriptions-item label="当前状态">
        <a-button
          @click="showWorkingConditions(deviceData.id, deviceData.continuousRunningDuration)"
          size="small"
          type="link"
          >{{
            deviceData.devCurStatus === null ? '非动设备' : deviceData.devCurStatus === 1 ? '运行' : '停止'
          }}</a-button
        >
      </a-descriptions-item>

      <a-descriptions-item label="连续运行">
        <a-button
          @click="showWorkingConditions(deviceData.id, deviceData.continuousRunningDuration)"
          size="small"
          type="link"
          >{{ deviceData.continuousRunningDuration | toHoursAndMinutes }}</a-button
        >
      </a-descriptions-item>
      <a-descriptions-item label="累计运行">
        <a-button
          @click="showWorkingConditions(deviceData.id, deviceData.totalRunningDuration)"
          size="small"
          type="link"
          >{{ deviceData.totalRunningDuration | toHoursAndMinutes }}</a-button
        >
      </a-descriptions-item>
      <a-descriptions-item label="剩余寿命">{{
        deviceData.runningLife | mathResidualLife(deviceData.totalRunningDuration)
      }}</a-descriptions-item>
      <a-descriptions-item label="下次保养">
        <span :style="{ 'word-wrap': 'break-word', 'background-color': nextMaintainColor, color: '#fff' }">{{
          nextMaintain
        }}</span>
      </a-descriptions-item>
    </a-descriptions>
    <base-info-modal :deviceData="deviceData" @ok="modalFormOk" ref="modalForm" size="small" />
    <RecordInfo :deviceData="deviceData" />
    <dev-working-conditions-detail-modal
      @ok="modalFormOk"
      ref="workingConditionsDetail"
    ></dev-working-conditions-detail-modal>
    <div class="ant-descriptions-title" style="margin-top: 20px;">备品备件消耗记录</div>
    <a-table
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      bordered
      class="j-table-force-nowrap"
      ref="bpbjLoTable"
      rowKey="id"
      size="middle"
    ></a-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseInfoModal from '../modal/BaseInfoModal.vue'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import DevWorkingConditionsDetailModal from '@views/monitor/working/modules/DevWorkingConditionsDetailModal'
import RecordInfo from './RecordInfo.vue'
import { httpAction, getAction } from '@/api/manage'
import moment from 'dayjs'

export default {
  name: 'TabPanelBase',
  mixins: [JeecgListMixin],
  components: {
    BaseInfoModal,
    /* DevRunningDetailModal, */
    DevWorkingConditionsDetailModal,
    RecordInfo
  },
  props: {
    deviceData: {
      type: Object,
      default: () => {}
    }
  },
  // 定义属性
  data() {
    return {
      putUrl: '/device/devList/edit',
      maintainTimerlist: '/maintenance/devMaintainceTimer/list',
      nextMaintain: '--',
      nextMaintainColor: '',
      queryParam: {
        devId: this.deviceData.id
      },
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      columns: [
        {
          title: '日期',
          align: 'center',
          dataIndex: 'createTime'
        },
        {
          title: '备件名称',
          align: 'center',
          dataIndex: 'bjName'
        },
        {
          title: '备件型号',
          align: 'center',
          dataIndex: 'bjModel'
        },
        {
          title: '领用数量',
          align: 'center',
          dataIndex: 'count'
        },
        {
          title: '单位',
          align: 'center',
          dataIndex: 'unit'
        },
        {
          title: '任务类型',
          align: 'center',
          dataIndex: 'taskTable_dictText'
        },
        {
          title: '任务单号',
          align: 'center',
          dataIndex: 'repairPlanId'
        }
      ],
      url: {
        list: '/spareparts/devBpbjLeadoutList/list'
      }
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {
    ...mapGetters([''])
  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getMaintainTimer()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  filters: {
    //将分钟转换为小时和分钟
    toHoursAndMinutes(totalMinutes) {
      if (!totalMinutes) return '--'
      const hours = Math.floor(totalMinutes / 60)
      const minutes = totalMinutes % 60
      // return { hours, minutes };
      return `${hours}小时${minutes}分`
    },
    //计算设备的剩余寿命（天 ，向下取整）   设备台账的寿命 - 累计运行时间
    mathResidualLife(runningLife, totalRunningDuration) {
      if (!runningLife) return '--'
      if (!totalRunningDuration) return `${runningLife}天`
      const days = (totalRunningDuration / 60 / 24).toFixed(2)
      const residualLife = Math.floor(runningLife - days)
      if (residualLife > 0) {
        return `${residualLife}天`
      } else {
        return `0天`
      }
    }
  },
  // 方法集合
  methods: {
    handleEdit: function() {
      this.$refs.modalForm.edit(this.deviceData)
      this.$refs.modalForm.title = '编辑'
      this.$refs.modalForm.disableSubmit = false
    },
    modalFormOk() {
      this.$emit('ok')
    },
    showWorkingConditions(devId, duration) {
      console.log(duration)
      if (duration === null) {
        this.$message.info('请先配置设备运行条件')
        return
      }
      this.$refs.workingConditionsDetail.show(devId)
    },
    getMaintainTimer() {
      const params = {
        devId: this.deviceData.id,
        pageNo: 1,
        pageSize: 9999
      }
      getAction(this.maintainTimerlist, params).then(res => {
        if (res.success) {
          if (res.result.total) {
            res.result.records.sort(
              (a, b) =>
                Math.min(a.nextTime, a.maintenanceIntervals - a.continuousRunningDuration) -
                Math.min(b.nextTime, b.maintenanceIntervals - b.continuousRunningDuration)
            )
            this.nextMaintain = this.convertNextTime(res.result.records[0])
            this.nextMaintainColor = this.getItemByTime(res.result.records[0])
          }
        }
      })
    },
    convertNextTime(record) {
      let resStr = ''
      if (record.tickingType === '1') {
        const lastMinutes = Math.max(record.maintenanceIntervals - record.continuousRunningDuration, 0)
        const hours = parseInt(lastMinutes / 60, 10)
        const minutes = lastMinutes % 60
        resStr =
          lastMinutes === 0
            ? moment().format('YYYY-MM-DD')
            : `继续运行 【${hours >= 1 ? hours + '小时' : ''}${minutes > 0 ? minutes + '分钟' : ''}】 后`
      } else {
        resStr = moment()
          .add(record.nextTime, 'minute')
          .format('YYYY-MM-DD')
      }
      return (
        resStr +
        `需完成 ${record.maintainStl?.projectName}：【${record.maintainStl?.maintenancePlace} - ${record.maintainStl?.maintenanceOperate}】`
      )
    },
    getItemByTime(record) {
      let color = '#52c41a'
      if (record.tickingType === '1') {
        if (record.continuousRunningDuration >= record.maintenanceIntervals) {
          color = '#ff4d4f'
        }
      } else {
        if (record.nextTime < 1440) {
          color = '#ff4d4f'
        } else if (record.nextTime < 1440 * 7) {
          color = '#faad14'
        }
      }
      return color
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
